// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallSelectSpeakersPopup__search-b3e739 {
  margin: 16px 24px;
}

.CallSelectSpeakersPopup__header-d9cf92 {
  justify-content: center;
}

.CallSelectSpeakersPopup__title-deb4da {
  font: var(--font-title-9);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.CallSelectSpeakersPopup__subtitle-d8c6c5 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/CallSelectSpeakersPopup/CallSelectSpeakersPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF","sourcesContent":[".search {\n  margin: 16px 24px;\n}\n\n.header {\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-title-9);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.subtitle {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `CallSelectSpeakersPopup__search-b3e739`,
	"header": `CallSelectSpeakersPopup__header-d9cf92`,
	"title": `CallSelectSpeakersPopup__title-deb4da`,
	"subtitle": `CallSelectSpeakersPopup__subtitle-d8c6c5`
};
module.exports = ___CSS_LOADER_EXPORT___;
